module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/1/2-d0a57b9806ccd1ce9e1cf29142a3db25.jpg";